<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.asName" style="width: 120px;" size="mini" placeholder="名称"
                        clearable></el-input>
                    <el-input v-model="formDatas.asNumber" style="width: 120px;" size="mini" placeholder="商户编码"
                        clearable></el-input>
                    <el-select size="mini" v-model="formDatas.ascId" clearable @change="cityChange" placeholder="请选择商户城市"
                        style="width: 130px">
                        <el-option v-for="item in getAjefShopCityList_data" :key="item.ascId" :label="item.ascName"
                            :value="item.ascId"></el-option>
                    </el-select>
                    <el-select size="mini" v-if="formDatas.ascId" v-model="formDatas.ascdId" clearable @change="partserch" placeholder="请选择商户区县"
                        style="width: 130px">
                        <el-option v-for="item in getAjefShopCityDistrictList_data" :key="item.ascdId" :label="item.ascdName"
                            :value="item.ascdId"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.asStatus" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 130px">
                        <el-option label="待提交" :value="1"></el-option>
                        <el-option label="待审核" :value="2"></el-option>
                        <el-option label="审核通过" :value="3"></el-option>
                        <el-option label="审核驳回" :value="4"></el-option>
                        <el-option label="撤销审核" :value="5"></el-option>
                        <el-option label="禁用商户" :value="6"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.asrtId" clearable @change="partserch"
                        placeholder="请选择开票结算类型" style="width: 130px">
                        <el-option v-for="item in getAjefShopReceiptTypeList_data" :key="item.asrtId"
                            :label="item.asrtReceiptTypeName" :value="item.asrtId"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.billShareType" clearable @change="partserch"
                        placeholder="请选择分账类型" style="width: 130px">
                        <el-option v-for="item in billShareTypeList" :key="item.asShareTypeId" :label="item.asShareTypeName" :value="item.asShareTypeId"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.astId" clearable @change="partserch"
                        placeholder="请选择商户类型" style="width: 130px">
                        <el-option v-for="item in getAjefShopTypeList_data" :key="item.astId"
                            :label="item.astName" :value="item.astId"></el-option>
                    </el-select>
                    <!-- 校验状态 -->
                    <el-select size="mini" v-model="formDatas.asStatusBankCheck" clearable @change="partserch"
                        placeholder="请选择对公信息校验状态" style="width: 150px">
                        <el-option label="未校验" :value="1" key="1"></el-option>
                        <el-option label="校验通过" :value="2" key="2"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="danger" size="mini" style="margin-left: 10px" @click="openBatchHeXiaoDialog('disable')">批量禁用核销</el-button>
                    <el-button type="success" size="mini" style="margin-left: 10px" @click="openBatchHeXiaoDialog('enable')">批量解禁核销</el-button>
                    <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button>
                    <!-- <el-button type="primary" size="mini" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button> -->
                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                    <!-- <el-button type="danger" size="mini" style="margin-left: 10px" @click="BulkDelete">批量删除</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增商户</el-button>

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="asId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑商户' : '新增商户'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="商户地址" prop="asCity">
                                <el-cascader v-model="asCity" :options="CityArr" :props="props" ref="cascader"
                                    @change="handleChange" @expand-change="expandChange"
                                    :placeholder="form.asCity == '' ? '请选择商户地址' : form.asCity"
                                    style="width: 80%;"></el-cascader>
                            </el-form-item>
                            <el-form-item label="商户名称" prop="asName">
                                <el-input v-model="form.asName" style="width: 80%;" placeholder="请输入名称"></el-input>
                            </el-form-item>
                            <el-form-item label="营业执照照片" prop="asBaseBusinessLicense">
                                <my-uploadOnly ref="upload" @fileChange="fileChange" :filearr="fileList" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="法人身份证人面" prop="asBaseIdcardFace">
                                <my-uploadOnly ref="upload" @fileChange="fileChange2" :filearr="fileList2" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter2"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="法人身份证国徽" prop="asBaseIdcardNationalEmblem">
                                <my-uploadOnly ref="upload" @fileChange="fileChange3" :filearr="fileList3" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter3"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="法人手机号" prop="asBaseLegalPersonPhone">
                                <el-input v-model="form.asBaseLegalPersonPhone" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="门头照片" prop="asBaseShopHeader">
                                <my-uploadOnly ref="upload" @fileChange="fileChange4" :filearr="fileList4" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter4"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="店内照片" prop="asBaseShopIn">
                                <my-uploadOnly ref="upload" @fileChange="fileChange5" :filearr="fileList5" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter5"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="对公账户户名" prop="asOpenName">
                                <el-input v-model="form.asOpenName" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="对公账户账号" prop="asOpenBankAccount">
                                <el-input v-model="form.asOpenBankAccount" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开户行名称" prop="asOpenBank">
                                <el-input v-model="form.asOpenBank" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开户许可证" prop="asOpenBankImage">
                                <my-uploadOnly ref="upload" @fileChange="fileChange6" :filearr="fileList6" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter6"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="邮箱" prop="asEmail">
                                <el-input v-model="form.asEmail" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="管理员姓名" prop="asAccountAdminName">
                                <el-input v-model="form.asAccountAdminName" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="管理员手机号" prop="asAccountAdmin">
                                <el-input v-model="form.asAccountAdmin" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="核销员姓名" prop="asAccountUserName">
                                <el-input v-model="form.asAccountUserName" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="核销员手机号" prop="asAccountUser">
                                <el-input v-model="form.asAccountUser" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="商户结算类型" prop="asrtId">
                                <el-select v-model="form.asrtId" style="width: 80%;" placeholder="请选择商户结算类型">
                                    <el-option v-for="item in getAjefShopReceiptTypeList_data" :key="item.asrtId"
                                        :label="item.asrtReceiptTypeName" :value="item.asrtId"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="排序" prop="asOrder">
                                <el-input-number v-model="form.asOrder" style="width: 80%;" :min="0" placeholder="请输入排序"></el-input-number>
                            </el-form-item>
                            <!-- <el-form-item label="商户编码" prop="asNumber">
                                <el-input v-model="form.asNumber" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="主体信息" prop="asMainBody">
                                <el-input v-model="form.asMainBody" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="经营信息" prop="asMainBusiness">
                                <el-input v-model="form.asMainBusiness" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="结算账户" prop="asSettlementAccount">
                                <el-input v-model="form.asSettlementAccount" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="商户号" prop="asWechatAccount">
                                <el-input v-model="form.asWechatAccount" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="商户地址" prop="asAddress">
                                <el-input v-model="form.asAddress" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item> -->
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 排序弹框 -->
            <el-dialog title="排序" :visible.sync="orderDialog" width="400px" :close-on-click-modal="false">
                <el-form label-width="80px">
                    <el-form-item label="排序值">
                        <el-input-number v-model="formOrder.asOrder" :min="0" placeholder="请输入排序值"></el-input-number>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="orderDialog = false">取 消</el-button>
                    <el-button type="primary" @click="sureOrderBtn">确 定</el-button>
                </div>
            </el-dialog>
            <!-- 编辑商户地市和名称弹窗 -->
            <el-dialog title="编辑商户地市和名称" :visible.sync="cityNameDialog" width="500px" :close-on-click-modal="false">
                <el-form label-width="80px">
                    <el-form-item label="商户地址">
                        <el-cascader v-model="editCityNameArr" :options="CityArr" :props="props" ref="cascaderEdit"
                            @change="handleEditCityChange" @expand-change="expandChange"
                            :placeholder="editCityName.asCity || '请选择商户地址'"
                            style="width: 100%;"></el-cascader>
                    </el-form-item>
                    <el-form-item label="商户名称">
                        <el-input v-model="editCityName.asName" placeholder="请输入商户名称"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="cityNameDialog = false">取 消</el-button>
                    <el-button type="primary" @click="saveCityNameBtn" :loading="cityNameLoading">确 定</el-button>
                </div>
            </el-dialog>
            <!-- 复审 -->
            <el-drawer :wrapperClosable="false" title="商户复核" :before-close="handleClose" :visible.sync="dialogFh"
                direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="商户地址" prop="asCity">
                                <el-cascader v-model="asCity" :options="CityArr" :props="props" ref="cascader"
                                    @change="handleChange" @expand-change="expandChange"
                                    :placeholder="form.asCity == '' ? '请选择商户地址' : form.asCity"
                                    style="width: 80%;"></el-cascader>
                            </el-form-item>
                            <el-form-item label="商户名称" prop="asName">
                                <el-input v-model="form.asName" style="width: 80%;" placeholder="请输入名称"></el-input>
                            </el-form-item>
                            <el-form-item label="营业执照照片" prop="asBaseBusinessLicense">
                                <my-uploadOnly ref="upload" @fileChange="fileChange" :filearr="fileList" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="法人身份证人面" prop="asBaseIdcardFace">
                                <my-uploadOnly ref="upload" @fileChange="fileChange2" :filearr="fileList2" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter2"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="法人身份证国徽" prop="asBaseIdcardNationalEmblem">
                                <my-uploadOnly ref="upload" @fileChange="fileChange3" :filearr="fileList3" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter3"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="法人手机号" prop="asBaseLegalPersonPhone">
                                <el-input v-model="form.asBaseLegalPersonPhone" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="门头照片" prop="asBaseShopHeader">
                                <my-uploadOnly ref="upload" @fileChange="fileChange4" :filearr="fileList4" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter4"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="店内照片" prop="asBaseShopIn">
                                <my-uploadOnly ref="upload" @fileChange="fileChange5" :filearr="fileList5" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter5"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="对公账户户名" prop="asOpenName">
                                <el-input v-model="form.asOpenName" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="对公账户账号" prop="asOpenBankAccount">
                                <el-input v-model="form.asOpenBankAccount" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开户行名称" prop="asOpenBank">
                                <el-input v-model="form.asOpenBank" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开户许可证" prop="asOpenBankImage">
                                <my-uploadOnly ref="upload" @fileChange="fileChange6" :filearr="fileList6" :limit="10"
                                    style="margin: 10px 5px 5px;" @removeAfter="removeAfter6"></my-uploadOnly>
                            </el-form-item>
                            <el-form-item label="邮箱" prop="asEmail">
                                <el-input v-model="form.asEmail" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="管理员姓名" prop="asAccountAdminName">
                                <el-input v-model="form.asAccountAdminName" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="管理员手机号" prop="asAccountAdmin">
                                <el-input v-model="form.asAccountAdmin" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="核销员姓名" prop="asAccountUserName">
                                <el-input v-model="form.asAccountUserName" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="核销员手机号" prop="asAccountUser">
                                <el-input v-model="form.asAccountUser" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="商户结算类型" prop="asrtId">
                                <el-select v-model="form.asrtId" style="width: 80%;" placeholder="请选择商户结算类型">
                                    <el-option v-for="item in getAjefShopReceiptTypeList_data" :key="item.asrtId"
                                        :label="item.asrtReceiptTypeName" :value="item.asrtId"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="排序" prop="asOrder">
                                <el-input-number v-model="form.asOrder" style="width: 80%;" :min="0" placeholder="请输入排序"></el-input-number>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtnFs" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 校验 -->
            <el-drawer :wrapperClosable="false" title="对公账户信息校验" :before-close="handleCheckClose"
                :visible.sync="isCheckBank" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">

                            <el-form-item label="对公账户户名" prop="asOpenName">
                                <el-input v-model="form.asOpenName" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="对公账户账号" prop="asOpenBankAccount">
                                <el-input v-model="form.asOpenBankAccount" style="width: 80%;"
                                    placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开户行名称" prop="asOpenBank">
                                <el-input v-model="form.asOpenBank" style="width: 80%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="开户许可证" prop="asOpenBankImage">
                                <my-uploadOnly ref="uploadCheckBank" @fileChange="fileChange6" :filearr="fileList6"
                                    :limit="10" style="margin: 10px 5px 5px;"
                                    @removeAfter="removeAfter6"></my-uploadOnly>
                            </el-form-item>
                            <!-- 对公校验状态 -->
                            <el-form-item label="对公信息校验状态" prop="asStatusBankCheck">
                                <el-select v-model="form.asStatusBankCheck" style="width: 80%;"
                                    placeholder="请选择对公信息校验状态">
                                    <el-option label="未校验" :value="1"></el-option>
                                    <el-option label="校验通过" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleCheckClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureCheckBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 商户用户 -->
            <el-dialog title="商户用户" :visible.sync="isMerchantUserShow" width="70%" top="8vh"
                :close-on-click-modal="false">
                <div style="width: 100%;height: 130px;display: flex;align-items: center;justify-content: space-between;margin: 20px 0;"
                    v-if="merchantDetail.ajefShopAccount">
                    <div style="width: 24%;height: 120px;margin: 10px auto;overflow: hidden;display: flex;
                    flex-direction: column;align-items: center;justify-content: center;padding: 15px;border-radius: 10px;
                    background-color:#F2F6FC; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);">
                        <div style="font-size: 15px;color:  #86909c;margin-bottom: 15px">总计</div>
                        <div style="font-size: 20px;color:  #86909c;margin-bottom: 10px;font-weight: 700;">
                            ¥{{ merchantDetail.ajefShopAccount.asaIncomeTotalYuan * 1 || '0' }}</div>
                    </div>
                    <div style="width: 24%;height: 120px;margin: 10px auto;overflow: hidden;display: flex;
                    flex-direction: column;align-items: center;justify-content: center;padding: 15px;border-radius: 10px;
                    background-color:#F2F6FC; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);">
                        <div style="font-size: 15px;color:  #86909c;margin-bottom: 15px">账户余额</div>
                        <div style="font-size: 20px;color:  #86909c;margin-bottom: 10px;font-weight: 700;">
                            ¥{{ merchantDetail.ajefShopAccount.asaBalanceYuan * 1 || '0' }}</div>
                        <div>
                            <el-button size="mini" type="primary"
                                @click="openMoneyBtn(merchantDetail.asId)">对公打款</el-button>
                        </div>
                    </div>
                    <div style="width: 24%;height: 120px;margin: 10px auto;overflow: hidden;display: flex;
                    flex-direction: column;align-items: center;justify-content: center;padding: 15px;border-radius: 10px;
                    background-color:#F2F6FC; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);">
                        <div style="font-size: 15px;color:  #86909c;margin-bottom: 15px">欠款金额</div>
                        <div style="font-size: 20px;color:  #86909c;margin-bottom: 10px;font-weight: 700;">
                            ¥{{ merchantDetail.ajefShopAccount.asaIncomeRevokeYuan * 1 || '0' }}</div>
                    </div>
                    <div style="width: 24%;height: 120px;margin: 10px auto;overflow: hidden;display: flex;
                    flex-direction: column;align-items: center;justify-content: center;padding: 15px;border-radius: 10px;
                    background-color:#F2F6FC; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);">
                        <div style="font-size: 15px;color:  #86909c;margin-bottom: 15px">累计收益</div>
                        <div style="font-size: 20px;color:  #86909c;margin-bottom: 10px;font-weight: 700;">
                            ¥{{ merchantDetail.ajefShopAccount.asaIncomeWithdrawYuan * 1 || '0' }}</div>
                    </div>
                </div>
                <div style="display: flex; width: 100%">
                    <div style="width: 95%; height: 40px">
                        <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                            <el-input v-model="formUserDatas.ausName" style="width: 120px;" size="mini" placeholder="名称"
                                clearable></el-input>
                            <el-input v-model="formUserDatas.ausPhone" style="width: 120px;" size="mini"
                                placeholder="手机号" clearable></el-input>
                            <el-select size="mini" v-model="formUserDatas.ausType" clearable
                                @change="getMerchantUserList" placeholder="请选择权限类型" style="width: 130px">
                                <el-option label="普通用户" :value="1"></el-option>
                                <el-option label="商户管理员" :value="2"></el-option>
                                <el-option label="商户核销员" :value="3"></el-option>
                            </el-select>
                            <el-select size="mini" v-model="formUserDatas.ausStatus" clearable
                                @change="getMerchantUserList" placeholder="请选择账号状态" style="width: 130px">
                                <el-option label="正常" :value="1"></el-option>
                                <el-option label="已禁用" :value="2"></el-option>
                                <el-option label="已删除" :value="3"></el-option>
                            </el-select>
                            <el-button type="info" size="mini" icon="el-icon-search" @click="getMerchantUserList"
                                style="margin-left: 10px">搜索</el-button>
                            <!-- <el-button type="primary" size="mini" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button> -->
                            <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                            <!-- <el-button type="danger" size="mini" style="margin-left: 10px" @click="BulkDelete">批量删除</el-button> -->
                        </el-row>
                    </div>
                    <div style="width: 10%; height: 40px">
                        <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                            <el-button type="success" size="mini" style="margin-right: 20px"
                                @click="addMerchantUser('1')">新增商户管理员</el-button>
                            <el-button type="success" size="mini" style="margin-right: 20px"
                                @click="addMerchantUser('2')">新增商户核销员</el-button>
                        </el-row>
                    </div>
                </div>
                <div>
                    <ve-table ref="vetable" :columns="columnsMerchantUser" :table-data="MerchantUserData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" row-key-field-name="ausId" style="width: 100%" />
                    <div v-show="MerchantUserData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCountUser" :page-index="formUserDatas.currentPage"
                        :page-size="formUserDatas.pageSize"
                        :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange_user" @on-page-size-change="pageSizeChange_User" />
                </div>
                <el-dialog :title="editUser == true ? '编辑用户' : '新增用户'" append-to-body :visible.sync="isUserShow"
                    width="70%" top="8vh" :close-on-click-modal="false">
                    <div class="demo-drawer__content" style="height: 90%;">
                        <el-form ref="formRef2" :model="formUser" label-position="top" style="height:100%">
                            <div
                                style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                                <el-form-item label="用户名" prop="ausName">
                                    <el-input v-model="formUser.ausName" style="width: 80%;"
                                        placeholder="请输入名称"></el-input>
                                </el-form-item>
                                <el-form-item label="归属门店" prop="ausBelong">
                                    <el-input v-model="formUser.ausBelong" style="width: 80%;"
                                        placeholder="请输入名称"></el-input>
                                </el-form-item>
                                <el-form-item label="手机号" prop="ausPhone">
                                    <el-input v-model="formUser.ausPhone" style="width: 80%;"
                                        placeholder="请输入"></el-input>
                                </el-form-item>
                                <el-form-item label="密码" prop="ausPw">
                                    <el-input v-model="formUser.ausPw" style="width: 80%;" placeholder="请输入"></el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                    <div slot="footer" class="dialog-footer" style="width:80%; margin: 10px auto;">
                        <el-button @click="handleUserClose()" style="margin-left: 20%;">取 消</el-button>
                        <el-button type="primary" @click="SureUserBtn" style="margin-left: 150px;">
                            确 定</el-button>
                    </div>
                </el-dialog>
            </el-dialog>

        </div>
        <el-dialog title="里程碑" :visible.sync="diaRecord" width="70%" top="8vh" :close-on-click-modal="false">
            <div>
                <ve-table ref="vetable" :columns="columnsRecord" :table-data="tableRecord" :max-height="tableHight"
                    :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                    row-key-field-name="asmId" style="width: 100%" />
                <div v-show="tableRecord.length == 0" class="empty-data">暂无数据</div>
            </div>
        </el-dialog>
        <el-dialog title="规格关联" :visible.sync="diaSpecsRelation" width="80%" top="8vh" :close-on-click-modal="false">
            <div v-loading="specsLoading">
                <!-- 商户详情 -->
                <el-card class="box-card" style="margin-bottom: 20px;">
                    <div slot="header" class="clearfix">
                        <span>商户详情</span>
                    </div>
                    <el-form label-width="120px" size="small">
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="商户名称:">
                                    <span>{{ merchantSpecsDetail.asName || '-' }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="商户编号:">
                                    <span>{{ merchantSpecsDetail.asNumber || '-' }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="联系电话:">
                                    <span>{{ merchantSpecsDetail.asBaseLegalPersonPhone || '-' }}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="商户地址:">
                                    <span>{{ merchantSpecsDetail.asCity || '-' }} {{ merchantSpecsDetail.asAddress || '' }}</span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="分润类型:">
                                    <span>{{ merchantSpecsDetail.billShareType == 1 ? '按比例' : merchantSpecsDetail.billShareType == 2 ? '按金额' : '-' }}</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-card>
                <!-- 规格列表展示 -->
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>规格列表</span>
                    </div>
                    <div v-if="specsList && specsList.length > 0">
                        <el-table :data="specsList" border style="width: 100%">
                            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                            <el-table-column prop="acrAmountStr" label="券面金额(元)" width="100" align="center"></el-table-column>
                            <el-table-column prop="specsOrder" label="排序" width="80" align="center"></el-table-column>
                            <el-table-column prop="specsNum" label="数量" width="80" align="center"></el-table-column>
                            <el-table-column label="描述" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.specsRelationShop && scope.row.specsRelationShop.relationName ? scope.row.specsRelationShop.relationName : '-' }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="图片" align="center" width="150">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.specsRelationShop && scope.row.specsRelationShop.relationImage" style="display: flex; flex-wrap: wrap; gap: 2px; justify-content: center;">
                                        <img v-for="(img, idx) in scope.row.specsRelationShop.relationImage.split(',')" :key="idx" :src="img" style="width: 40px; height: 40px; object-fit: contain; cursor: pointer;" @click="handlePreviewImage(scope.row.specsRelationShop.relationImage.split(','))">
                                    </div>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="描述-待审核" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.specsRelationShop && scope.row.specsRelationShop.relationNamePreparing ? scope.row.specsRelationShop.relationNamePreparing : '-' }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="图片-待审核" align="center" width="150">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.specsRelationShop && scope.row.specsRelationShop.relationImagePreparing" style="display: flex; flex-wrap: wrap; gap: 2px; justify-content: center;">
                                        <img v-for="(img, idx) in scope.row.specsRelationShop.relationImagePreparing.split(',')" :key="idx" :src="img" style="width: 40px; height: 40px; object-fit: contain; cursor: pointer;" @click="handlePreviewImage(scope.row.specsRelationShop.relationImagePreparing.split(','))">
                                    </div>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="是否上架" align="center" width="80">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.specsRelationShop">{{ scope.row.specsRelationShop.acrsrsStatus == 2 ? '是' : '否' }}</span>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="审核状态" align="center" width="100">
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.specsRelationShop && scope.row.specsRelationShop.acrsrsStatusCheck == 1" type="info" size="mini">待提交</el-tag>
                                    <el-tag v-else-if="scope.row.specsRelationShop && scope.row.specsRelationShop.acrsrsStatusCheck == 2" type="warning" size="mini">待审核</el-tag>
                                    <el-tag v-else-if="scope.row.specsRelationShop && scope.row.specsRelationShop.acrsrsStatusCheck == 3" type="success" size="mini">审核通过</el-tag>
                                    <el-tag v-else-if="scope.row.specsRelationShop && scope.row.specsRelationShop.acrsrsStatusCheck == 4" type="danger" size="mini">驳回审核</el-tag>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="140" align="center">
                                <template slot-scope="scope">
                                    <el-button size="mini" type="text" @click="openSpecsEditDialog(scope.row)">编辑</el-button>
                                    <el-button v-if="scope.row.specsRelationShop && scope.row.specsRelationShop.acrsrsStatus == 1" size="mini" type="text" style="color: #67C23A;" @click="handleSpecsShelfUp(scope.row)">上架</el-button>
                                    <el-button v-if="scope.row.specsRelationShop && scope.row.specsRelationShop.acrsrsStatus == 2" size="mini" type="text" style="color: #F56C6C;" @click="handleSpecsShelfDown(scope.row)">下架</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div v-else class="empty-data">暂无规格数据</div>
                </el-card>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="diaSpecsRelation = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 规格编辑弹框 -->
        <el-dialog title="编辑规格关联" :visible.sync="diaSpecsEdit" width="500px" :close-on-click-modal="false">
            <el-form :model="specsEditForm" label-width="120px">
                <el-form-item label="券面金额:">
                    <span>{{ specsEditForm.acrAmountStr }}元</span>
                </el-form-item>
                <el-form-item label="描述-待审核:">
                    <el-input v-model="specsEditForm.relationNamePreparing" placeholder="请输入描述" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="图片-待审核:">
                    <div v-if="specsEditForm.relationImagePreparing && specsEditForm.relationImagePreparing.length > 0" style="display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 10px;">
                        <div v-for="(img, index) in specsEditForm.relationImagePreparing" :key="index" style="position: relative;">
                            <img :src="img" style="width: 100px; height: 100px; object-fit: contain;" @click="handlePreviewImage(img)">
                            <i class="el-icon-close" style="position: absolute; top: -8px; right: -8px; cursor: pointer; color: #F56C6C; font-size: 18px;" @click="removeSpecsEditImage(index)"></i>
                        </div>
                    </div>
                    <my-uploadOnly ref="uploadSpecsEdit" @fileChange="specsEditFileChange" :filearr="specsEditForm.relationImagePreparing ? specsEditForm.relationImagePreparing.map(url => ({url: url})) : []" :limit="99" accept="image/*"></my-uploadOnly>
                </el-form-item>
                <el-form-item label="是否提交审核:">
                    <el-select v-model="specsEditForm.acrsrsStatusCheck" placeholder="请选择是否提交审核" style="width: 200px;" clearable>
                        <el-option label="否" :value="1"></el-option>
                        <el-option label="是" :value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="diaSpecsEdit = false">取消</el-button>
                <el-button type="primary" @click="saveSpecsEdit">保存</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="makeData.length > 0 ? '与移动存量客户关联商户' : '没有查询到,请自行到商家库查询'" :visible.sync="isMakeShow"
            width="70%" top="8vh" :close-on-click-modal="false">
            <div>
                <ve-table ref="vetable" :columns="columnsMake" :table-data="makeData" :max-height="tableHight"
                    :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                    row-key-field-name="assyId" style="width: 100%" />
            </div>
            <div slot="footer" class="dialog-footer" style="width:80%; margin: 10px auto;">
                <el-button type="danger" @click="handleRefuseCheck(theRow)" style="margin-left: 20%;">驳回审核</el-button>
                <el-button type="primary" @click="handleCheck(theRow)" style="margin-left: 150px;">
                    通过审核</el-button>
            </div>
        </el-dialog>
        <el-dialog title="图片信息" :visible.sync="isImgMsgShow" width="70%" top="8vh" :close-on-click-modal="false">
            <div>
                <ve-table ref="vetable3" :columns="columnsImgMsg" :table-data="DetailImgMsg" :max-height="tableHight"
                    :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
                    row-key-field-name="ausId" style="width: 100%" />
            </div>
        </el-dialog>
        <!-- 商户介绍弹框 -->
        <el-dialog
            :title="'商户介绍 - ' + (introductionCurrentShop ? introductionCurrentShop.asName : '')"
            :visible.sync="introductionDialog"
            width="600px"
            top="5vh"
            :close-on-click-modal="false"
            @close="handleIntroductionClose">
            <div v-loading="introductionLoading" style="min-height: 200px; max-height: 60vh; overflow-y: auto;">
                <!-- 已上传图片列表 - 电商长图风格 -->
                <div class="introduction-image-list" v-if="introductionFileList.length > 0">
                    <div class="introduction-image-item" v-for="(item, index) in introductionFileList" :key="index">
                        <el-image
                            :src="item.url"
                            fit="contain"
                            class="introduction-img"
                            :preview-src-list="introductionFileList.map(f => f.url)"
                            :z-index="9999">
                        </el-image>
                        <div class="introduction-image-delete" @click="handleIntroductionImageDelete(index)">
                            <i class="el-icon-delete"></i>
                        </div>
                    </div>
                </div>
                <!-- 上传区域 -->
                <div class="introduction-upload-area">
                    <my-uploadOnly
                        ref="uploadIntroduction"
                        @fileChange="handleIntroductionFileChange"
                        :filearr="[]"
                        :limit="99"
                        accept="image/*">
                    </my-uploadOnly>
                </div>
                <!-- 空状态提示 -->
                <div v-if="introductionFileList.length === 0 && !introductionLoading" class="introduction-empty">
                    <i class="el-icon-picture-outline"></i>
                    <p>暂无商户介绍图片，请上传</p>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="introductionDialog = false">取 消</el-button>
                <el-button type="primary" @click="handleIntroductionSave" :loading="introductionLoading">保 存</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改分账类型" :visible.sync="billShareTypeShow" width="70%" top="8vh" :close-on-click-modal="false">
            <div>
                <el-form :model="formBillShareType" ref="formBillShareType" label-width="100px">
                    <el-form-item label="商户类型" prop="asrtType">
                        <el-select v-model="formBillShareType.asrtType" placeholder="请选择类型" @change="changeType">
                            <el-option label="子商户" :value="1"></el-option>
                            <el-option label="本地非渠道" :value="2"></el-option>
                            <el-option label="特殊商户_折扣77%" :value="3"></el-option>
                            <el-option label="体检_折扣40%" :value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="商户结算类型" prop="asrtId" v-if="formBillShareType.asrtType">
                        <el-select v-model="formBillShareType.asrtId" placeholder="请选择商户结算类型">
                            <el-option v-for="item in getAjefShopReceiptTypeList_data2" :key="item.asrtId"
                                :label="item.asrtReceiptTypeName" :value="item.asrtId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="分账类型" prop="billShareType">
                        <el-select v-model="formBillShareType.billShareType" placeholder="请选择分账类型">
                            <el-option v-for="item in billShareTypeList" :key="item.asShareTypeId" :label="item.asShareTypeName" :value="item.asShareTypeId"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer" style="width:80%; margin: 10px auto;">
                <el-button type="danger" @click="handleTypeClose()" style="margin-left: 20%;">取消</el-button>
                <el-button type="primary" @click="SureTypeBtn()" style="margin-left: 150px;">
                    确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改商户类型" :visible.sync="shopTypeShow" width="40%" top="30vh" :close-on-click-modal="false">
            <div>
                <el-form :model="formShopType" ref="formShopType" label-width="100px">
                    <el-form-item label="商户类型" prop="astId">
                        <el-select v-model="formShopType.astId" placeholder="请选择商户类型" style="width: 80%;">
                            <el-option v-for="item in getAjefShopTypeList_data" :key="item.astId"
                                :label="item.astName" :value="item.astId"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer" style="width:80%; margin: 10px auto;">
                <el-button @click="handleShopTypeClose()" style="margin-left: 20%;">取消</el-button>
                <el-button type="primary" @click="SureShopTypeBtn()" style="margin-left: 150px;">
                    确定</el-button>
            </div>
        </el-dialog>
        <!-- 批量禁用/解禁核销弹窗 -->
        <el-dialog :title="batchHeXiaoType == 'disable' ? '批量禁用商户核销' : '批量解禁商户核销'" :visible.sync="batchHeXiaoDialog" width="600px" :close-on-click-modal="false">
            <el-form label-width="100px">
                <el-form-item label="选择商户">
                    <el-radio-group v-model="batchHeXiaoSelectType">
                        <el-radio label="select">选择商户</el-radio>
                        <el-radio label="upload">上传文件</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="商户" v-if="batchHeXiaoSelectType == 'select'">
                    <el-select v-model="batchHeXiaoAsIds" multiple filterable placeholder="请选择商户" style="width: 100%;">
                        <el-option v-for="item in getAjefShopListQuick_data" :key="item.asId" :label="item.asName" :value="item.asId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="上传文件" v-if="batchHeXiaoSelectType == 'upload'">
                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="handleBatchHeXiaoUpload" :auto-upload="false" ref="batchHeXiaoUpload" :show-file-list="false">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <div v-if="batchHeXiaoAsIds.length > 0" style="margin-top: 10px; color: #67C23A;">已选择 {{ batchHeXiaoAsIds.length }} 个商户</div>
                </el-form-item>
                <el-form-item label="说明">
                    <el-input v-model="batchHeXiaoDes" type="textarea" :rows="3" placeholder="请输入说明（选填）" style="width: 100%;"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeBatchHeXiaoDialog">取 消</el-button>
                <el-button type="primary" @click="submitBatchHeXiao" :loading="batchHeXiaoLoading">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 批量操作结果弹窗 -->
        <el-dialog title="批量操作结果" :visible.sync="batchHeXiaoResultDialog" width="700px" :close-on-click-modal="false">
            <div v-if="batchHeXiaoResultList.length > 0">
                <el-alert title="以下商户处理失败" type="warning" :closable="false" style="margin-bottom: 15px;"></el-alert>
                <el-table :data="batchHeXiaoResultList" border style="width: 100%" max-height="400">
                    <el-table-column prop="asId" label="商户ID" width="100" align="center"></el-table-column>
                    <el-table-column prop="asName" label="商户名称" align="center"></el-table-column>
                    <el-table-column prop="asNumber" label="商户编码" align="center"></el-table-column>
                    <el-table-column prop="status" label="状态" width="80" align="center">
                        <template slot-scope="scope">
                            <el-tag type="danger">{{ scope.row.status }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="statusMsg" label="失败原因" align="center"></el-table-column>
                </el-table>
            </div>
            <div v-else>
                <el-alert title="批量操作成功" type="success" :closable="false"></el-alert>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeBatchHeXiaoResultDialog">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {
    updateAjefShopBillShareTypeShop,
    updateAjefShopTypeShop, updateAjefShopDisable, updateAjefShopEnable, updateAjefShopDisableHeXiao, updateAjefShopEnableHeXiao, updateAjefShopDisableHeXiaoMulti, updateAjefShopEnableHeXiaoMulti,
    updateAjefShopCheckBefore, getAjefShopCityList, getAjefShopCityDistrictList, addAjefShopAgain, getAjefShopMilestoneList, addAjefApplyWithdrawPublicSys, updateAjefShopBankCheck,
    getAjefShopList, addAjefShop, updateAjefShop, deleteAjefShop, getAjefShopDetails, updateAjefShopCheckPass, updateAjefShopCheckNotPass, updateAjefShopCheckPassGift, updateAjefShopOrder,
    getAjefUserShopList, addAjefUserShopAdmin, addAjefUserShopUser, updateAjefUserShop, deleteAjefUserShop, getAjefShopReceiptTypeList, getSysRegionList,
    getAjefShopDetailsGoodsSpecs, addOrUpdateAjefCertificateRecordSpecsRelationShop,
    updateAjefCertificateRecordSpecsRelationShopUp, updateAjefCertificateRecordSpecsRelationShopDown, getAjefShopTypeList, getAjefShopBillShareTypeList,
    updateAjefShopCityAndName, getAjefShopListQuick, uploadShopReturnAsIdsList,
    getAjefShopExpandDetails, updateAjefShopExpandIntroduce
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            // 分账类型列表
            billShareTypeList: [],
            isCheckBank: false,
            tableLoading: false,
            isImgMsgShow: false,
            DetailImgMsg: [],
            getAjefShopReceiptTypeList_data2: [],
            getAjefShopTypeList_data: [],
            billShareTypeShow: false,
            shopTypeShow: false,
            // 批量禁用/解禁核销相关
            batchHeXiaoDialog: false,
            batchHeXiaoType: 'disable', // disable 或 enable
            batchHeXiaoSelectType: 'select', // select 或 upload
            batchHeXiaoAsIds: [],
            batchHeXiaoDes: '',
            batchHeXiaoLoading: false,
            batchHeXiaoResultDialog: false,
            batchHeXiaoResultList: [],
            getAjefShopListQuick_data: [],
            formShopType: {
                astId: '',
                asId: ''
            },
            formBillShareType: {
                billShareType: '',
                asId: ''
            },
            diaRecord: false,
            diaSpecsRelation: false,
            tableRecord: [],
            columnsRecord: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "asmTitle",
                    key: "asmTitle",
                    title: "标题",
                    align: "center",
                },
                {
                    field: "asmContent",
                    key: "asmContent",
                    title: "内容",
                    align: "center",
                },
                {
                    field: "createusername",
                    key: "createusername",
                    title: "创建人",
                    align: "center",
                },
                {
                    field: "createtime",
                    key: "createtime",
                    title: "创建时间",
                    align: "center",
                },
            ],
            columnsSpecsRelation: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "specsName",
                    key: "specsName",
                    title: "商品名称",
                    align: "center",
                },
                {
                    field: "specsSku",
                    key: "specsSku",
                    title: "商品编码",
                    align: "center",
                },
                {
                    field: "acrsbAmount",
                    key: "acrsbAmount",
                    title: "券面金额(元)",
                    align: "center",
                },
                {
                    field: "acrsbGoodNum",
                    key: "acrsbGoodNum",
                    title: "北国商品编码",
                    align: "center",
                },
                {
                    field: "acrsbOrder",
                    key: "acrsbOrder",
                    title: "排序",
                    align: "center",
                },
            ],
            dialogFh: false,
            getAjefShopCityList_data: [],
            getAjefShopCityDistrictList_data: [],
            isMakeShow: false,
            columnsMake: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "assyName",
                    key: "assyName",
                    title: "商户名称",
                    align: "center",
                },

            ],
            makeData: [],
            asCity: '',
            props: {
                lazy: true,
                lazyLoad(node, resolve) {
                    console.log(node);
                    const { level } = node;
                    getSysRegionList({ srSuperiorCode: node.value }).then(res => {
                        if (res.data) {
                            const nodes = res.data.map(item => ({
                                value: item.srCode,
                                label: item.srName,
                                leaf: level >= 2
                            }))
                            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                            resolve(nodes);
                        }
                    })
                },

            },
            CityArr: [],
            getAjefShopReceiptTypeList_data: [],
            merchantDetail: {},
            fileList: [],
            fileList2: [],
            fileList3: [],
            fileList4: [],
            fileList5: [],
            fileList6: [],
            // 商户介绍弹框相关
            introductionDialog: false,
            introductionLoading: false,
            introductionForm: {
                aseId: null,
                asId: null,
                aseIntroduce: []
            },
            introductionFileList: [],
            introductionCurrentShop: null,
            totalCountUser: 0,
            isUserShow: false,
            editUser: false,
            orderDialog: false,
            formUser: {},
            theRowId: '',
            currentSpecsShopId: '',
            merchantSpecsDetail: {},
            specsList: [],
            specsLoading: false,
            diaSpecsEdit: false,
            specsEditForm: {
                specsId: '',
                acrAmountStr: '',
                acrsrsId: '',
                relationImagePreparing: [],
                relationNamePreparing: '',
                acrsrsStatusCheck: null
            },
            theAddType: '',
            formUserDatas: {
                currentPage: 1,
                pageSize: 10,
            },
            isMerchantUserShow: false,
            MerchantUserData: [],
            columnsMerchantUser: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "ausName",
                    key: "ausName",
                    title: "用户名",
                    align: "center",
                    fixed: 'left',
                    width: 120,
                },
                // {
                //     field: "ausOpenid",
                //     key: "ausOpenid",
                //     title: "openId",
                //     align: "center",
                //     width: 120,
                // },
                {
                    field: "ausBelong",
                    key: "ausBelong",
                    title: "归属门店",
                    align: "center",
                    width: 120,
                },
                {
                    field: "ausPhone",
                    key: "ausPhone",
                    title: "手机号",
                    align: "center",
                    width: 120,
                },
                {
                    field: "ausType",
                    key: "ausType",
                    title: "权限类型",
                    align: "center",
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.ausType == 1 ? <el-tag size="mini" type="danger">普通用户</el-tag> :
                                        row.ausType == 2 ? <el-tag size="mini" type="success">管理员</el-tag> :
                                            <el-tag size="mini" type="success">核销员</el-tag>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "ausStatus",
                    key: "ausStatus",
                    title: "状态",
                    align: "center",
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.ausStatus == 1 ? <el-tag size="mini" type="success">正常</el-tag> :
                                        row.acrStatus == 2 ? <el-tag size="mini" type="danger">已禁用</el-tag> : <el-tag type="danger" size="mini">已删除</el-tag>
                                }
                            </span>
                        );
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleUserEdit(row)}
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleUserDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ],

            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            statusAll: [
                { id: 1, name: "闲置" },
                { id: 2, name: "领用" },
                { id: 3, name: "损坏" },
                { id: 4, name: "丢失" },
            ],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'asId',
            dialog: false,
            edit: false,
            form: {
                asOrder: 0,
                asBaseBusinessLicense: [],
                asBaseIdcardFace: [],
                asBaseIdcardNationalEmblem: [],
                asBaseShopHeader: [],
                asBaseShopIn: [],
                asOpenBankImage: [],
            },
            // 排序表单
            formOrder: {
                asId: '',
                asOrder: 0,
                detailData: {}
            },
            // 编辑商户地市和名称
            cityNameDialog: false,
            cityNameLoading: false,
            editCityNameArr: [],
            editCityName: {
                asId: '',
                asCity: '',
                asName: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: false,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columnsImgMsg: [{
                field: "",
                key: "a",
                title: "序号",
                width: 50,
                fixed: 'left',
                align: "center",
                renderBodyCell: ({ row, column, rowIndex }, h) => {
                    return ++rowIndex;
                },
            },
            {
                field: "asBaseBusinessLicense",
                key: "asBaseBusinessLicense",
                title: "营业执照照片",
                edit: false,
                align: "center",
                width: 160,
                renderBodyCell: ({ row, column, rowIndex }, h) => {
                    return (
                        <span style="display:flex;align-items: center;">
                            <div style="width:100%;">
                                {
                                    row.asBaseBusinessLicense ? row.asBaseBusinessLicense.split(',').map((item => {
                                        const str = <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="scale-down" style="width: 50px;height: 50px;display: inline-block;"
                                            previewSrcList={[item]}></el-image>
                                        return str
                                    })) : ''
                                }

                            </div>
                        </span>
                    );
                },
            },
            {
                field: "asBaseIdcardFace",
                key: "asBaseIdcardFace",
                title: "法人身份证人面",
                align: "center",
                edit: false,
                width: 150,
                renderBodyCell: ({ row, column, rowIndex }, h) => {
                    return (
                        <span style="display:flex;align-items: center;">
                            <div style="width:100%;">
                                {
                                    row.asBaseIdcardFace ? row.asBaseIdcardFace.split(',').map((item => {
                                        const str = <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="scale-down" style="width: 50px;height: 50px;display: inline-block;"
                                            previewSrcList={[item]}></el-image>
                                        return str
                                    })) : ''
                                }

                            </div>
                        </span>
                    );
                },
            },
            {
                field: "asBaseIdcardNationalEmblem",
                key: "asBaseIdcardNationalEmblem",
                title: "法人身份证国徽",
                align: "center",
                edit: false,
                width: 150,
                renderBodyCell: ({ row, column, rowIndex }, h) => {
                    return (
                        <span style="display:flex;align-items: center;">
                            <div style="width:100%;">
                                {
                                    row.asBaseIdcardNationalEmblem ? row.asBaseIdcardNationalEmblem.split(',').map((item => {
                                        const str = <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="scale-down" style="width: 50px;height: 50px;display: inline-block;"
                                            previewSrcList={[item]}></el-image>
                                        return str
                                    })) : ''
                                }

                            </div>
                        </span>
                    );
                },
            },
            {
                field: "asBaseShopHeader",
                key: "asBaseShopHeader",
                edit: false,
                title: "门头照片",
                align: "center",
                width: 200,
                renderBodyCell: ({ row, column, rowIndex }, h) => {
                    return (
                        <span style="display:flex;align-items: center;">
                            <div style="width:100%;">
                                {
                                    row.asBaseShopHeader ? row.asBaseShopHeader.split(',').map((item => {
                                        const str = <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="scale-down" style="width: 50px;height: 50px;display: inline-block;"
                                            previewSrcList={[item]}></el-image>
                                        return str
                                    })) : ''
                                }

                            </div>
                        </span>
                    );
                },
            },
            {
                field: "asBaseShopIn",
                key: "asBaseShopIn",
                title: "店内照片",
                width: 200,
                edit: false,
                align: "center",
                renderBodyCell: ({ row, column, rowIndex }, h) => {
                    return (
                        <span style="display:flex;align-items: center;">
                            <div style="width:100%;">
                                {
                                    row.asBaseShopIn ? row.asBaseShopIn.split(',').map((item => {
                                        const str = <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="scale-down" style="width: 50px;height: 50px;display: inline-block;"
                                            previewSrcList={[item]}></el-image>
                                        return str
                                    })) : ''
                                }

                            </div>
                        </span>
                    );
                },
            },
            {
                field: "asOpenBankImage",
                key: "asOpenBankImage",
                title: "开户许可证",
                align: "center",
                edit: false,
                width: 140,
                renderBodyCell: ({ row, column, rowIndex }, h) => {
                    return (
                        <span style="display:flex;align-items: center;">
                            <div style="width:100%;">
                                {
                                    row.asOpenBankImage ? row.asOpenBankImage.split(',').map((item => {
                                        const str = <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="scale-down" style="width: 50px;height: 50px;display: inline-block;"
                                            previewSrcList={[item]}></el-image>
                                        return str
                                    })) : ''
                                }

                            </div>
                        </span>
                    );
                },
            },

            ],
            columns: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     // type=checkbox
                //     type: "checkbox",
                //     fixed: 'left',
                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },

                {
                    field: "asName",
                    key: "asName",
                    title: "商户名称",
                    align: "center",
                    edit: false,
                    fixed: 'left',
                    width: 200,
                },
                {
                    field: "i",
                    key: "i",
                    title: "图片信息",
                    align: "center",
                    fixed: 'left',
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>

                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color:green;margin-left:10px"
                                        on-click={() => this.getDetailImgMsg(row)}
                                    >
                                        查看详情
                                    </el-button>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "asNumber",
                    key: "asNumber",
                    title: "商户编码",
                    // fixed: 'left',
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "billShareType",
                    key: "billShareType",
                    title: "分账类型",
                    align: "center",
                    width: 160,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        const typeItem = this.billShareTypeList.find(item => item.asShareTypeId === row.billShareType);
                        return (
                            <span>
                                {typeItem ? <el-tag size="mini">{typeItem.asShareTypeName}</el-tag> : ''}
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color:red;margin-left:10px"
                                        on-click={() => this.handleBillShareType(row)}
                                    >
                                        修改
                                    </el-button>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "astName",
                    key: "astName",
                    title: "商户类型",
                    align: "center",
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.astName ? <el-tag size="mini">{row.astName}</el-tag> : '-'
                                }
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color:red;margin-left:10px"
                                        on-click={() => this.handleShopType(row)}
                                    >
                                        修改
                                    </el-button>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "asStatus",
                    key: "asStatus",
                    title: "状态",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {

                                    row.asStatus == 1 ? <el-tag size="mini" >待提交</el-tag> :
                                        row.asStatus == 2 ? <el-tag size="mini" type="danger">待审核</el-tag> :
                                            row.asStatus == 3 ? <el-tag type="success" size="mini">审核通过</el-tag> :
                                                row.asStatus == 4 ? <el-tag size="mini" type="danger">审核驳回</el-tag> :
                                                    row.asStatus == 5 ? <el-tag size="mini" type="info">撤销审核</el-tag> : <el-tag type="danger" size="mini">禁用商户</el-tag>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "asHexiaoStatus",
                    key: "asHexiaoStatus",
                    title: "核销状态",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {

                                    row.asHexiaoStatus == 1 ? <el-tag size="mini" type="success">允许核销</el-tag> :
                                        row.asHexiaoStatus == 2 ? <el-tag size="mini" type="danger">禁用核销</el-tag> :
                                            ''
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "asCity",
                    key: "asCity",
                    title: "商户地址",
                    align: "center",
                    width: 280,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <span style="margin-right: 8px;">{row.asCity || '-'}</span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: #409EFF;"
                                    on-click={() => this.openCityNameDialog(row)}
                                >
                                    编辑
                                </el-button>
                            </span>
                        );
                    },
                },

                {
                    width: 120,
                    field: "asBaseLegalPersonPhone",
                    key: "asBaseLegalPersonPhone",
                    edit: false,
                    title: "法人手机号",
                    align: "center",
                },

                {
                    field: "asOpenName",
                    key: "asOpenName",
                    title: "对公账户户名",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "asOpenBank",
                    key: "asOpenBank",
                    title: "开户行名称",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "asOpenBankAccount",
                    key: "asOpenBankAccount",
                    title: "对公账户账号",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                // 是否校验 asStatusBankCheck
                {
                    field: "asStatusBankCheck",
                    key: "asStatusBankCheck",
                    title: "对公打款信息校验",
                    align: "center",
                    edit: false,
                    width: 160,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {

                                    row.asStatusBankCheck == 1 ? <el-tag size="mini" type="danger">未校验</el-tag> :
                                        row.asStatusBankCheck == 2 ? <el-tag type="success" size="mini">校验成功</el-tag> :
                                            ''

                                }
                                {
                                        <el-button
                                            size="mini"
                                            type="text"
                                            style="color:red;margin-left:15px"
                                            on-click={() => this.checkBankInfo(row)}
                                        >
                                            校验
                                        </el-button>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "asEmail",
                    key: "asEmail",
                    title: "邮箱",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "asAccountAdminName",
                    key: "asAccountAdminName",
                    title: "管理员姓名",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "asAccountAdmin",
                    key: "asAccountAdmin",
                    title: "管理员手机号",
                    align: "center",
                    edit: false,
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style={{ color: row.asAccountAdmin == row.asAccountUser ? 'red' : 'black' }} >{row.asAccountAdmin}</span>
                        );
                    }


                },
                {
                    field: "asAccountUserName",
                    key: "asAccountUserName",
                    title: "核销员姓名",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "asAccountUser",
                    key: "asAccountUser",
                    title: "核销账号",
                    align: "center",
                    edit: false,
                    width: 140,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style={{ color: row.asAccountAdmin == row.asAccountUser ? 'red' : 'black' }} >{row.asAccountUser}</span>
                        );
                    }
                },
                {
                    field: "asrtReceiptTypeName",
                    key: "asrtReceiptTypeName",
                    title: "开票结算类型",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "asMainBody",
                    key: "asMainBody",
                    title: "主体信息",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "asMainBusiness",
                    key: "asMainBusiness",
                    title: "经营信息",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "asSettlementAccount",
                    key: "asSettlementAccount",
                    title: "结算账户",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "asWechatAccount",
                    key: "asWechatAccount",
                    title: "商户号",
                    align: "center",
                    width: 120,
                },
                {
                    field: "asAddress",
                    key: "asAddress",
                    title: "商户地址",
                    align: "center",
                    width: 120,
                },



                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "asCheckDes",
                    key: "asCheckDes",
                    title: "审核信息",
                    align: "center",
                    width: 120,
                },


                {
                    field: "asCheckPass",
                    key: "asCheckPass",
                    title: "审核状态",
                    align: "center",
                    fixed: 'right',
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>

                                {
                                    row.asStatus == 2 ?
                                        <el-button
                                            size="mini" type="text" style="color:red" on-click={() => this.handleCheckTable(row)} > 审核 </el-button> : <span></span>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "",
                    key: "f",
                    title: "操作",
                    width: 300,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.asStatus == 6 ?
                                        <el-button
                                            size="mini"
                                            type="text"
                                            on-click={() => this.handleEnable(row)}
                                        >
                                            解禁商户
                                        </el-button> : <el-button
                                            size="mini"
                                            type="text"
                                            style="color: red"
                                            on-click={() => this.handleDisable(row)}
                                        >
                                            禁用商户
                                        </el-button>
                                }
                                {
                                    row.asHexiaoStatus == 2 ?
                                        <el-button
                                            size="mini"
                                            type="text"
                                            on-click={() => this.handleEnableHeXiao(row)}
                                        >
                                            解禁商户核销
                                        </el-button> : <el-button
                                            size="mini"
                                            type="text"
                                            style="color: red"
                                            on-click={() => this.handleDisableHeXiao(row)}
                                        >
                                            禁用商户核销
                                        </el-button>
                                }
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color:green"
                                    on-click={() => this.handleRecord(row)}
                                >
                                    操作记录
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color:red"
                                    on-click={() => this.handleReview(row)}
                                >
                                    商户复核
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleTopUpMoney(row)}
                                >
                                    充值奖励
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: #E6A23C"
                                    on-click={() => this.handleSpecsRelation(row)}
                                >
                                    规格关联
                                </el-button>


                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>


                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: green"
                                    on-click={() => this.handleMerchantUser(row)}
                                >
                                    商户用户
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑
                                </el-button>
                                 <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEditOrder(row)}
                                >
                                    排序
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: #409EFF"
                                    on-click={() => this.handleIntroduction(row)}
                                >
                                    商户介绍
                                </el-button>

                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
                ascId: '',
                ascdId: '',
                astId: '',
            },
            bulkImport: false,
            bulkData: [],
            bulkDataCopy: [],
            sitId: '',
            importData: {},

        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getAjefShopReceiptTypeList({ pageSize: 0 }).then(res => {
            this.getAjefShopReceiptTypeList_data = res.data;
        });
        getSysRegionList().then(res => {
            res.data.forEach((item, index) => {
                const obj = {
                    value: item.srCode,
                    label: item.srName,
                    children: [],
                }
                this.CityArr.push(obj)
            })
        })
        getAjefShopCityList({ pageSize: 0 }).then(res => {
            this.getAjefShopCityList_data = res.data
        })
        // 加载商户类型列表
        getAjefShopTypeList({  pageSize: 0 }).then(res => {
            this.getAjefShopTypeList_data = res.data || []
        })
        // 加载区县列表
        this.loadDistrictList();
        // 加载分账类型列表
        this.getBillShareTypeList();
        this.getList();
    },
    mounted() { },
    methods: {
        // 获取分账类型列表
        getBillShareTypeList() {
            getAjefShopBillShareTypeList().then(res => {
                this.billShareTypeList = res.data || [];
            });
        },
        // 城市选择变化时加载区县
        cityChange(ascId) {
            this.formDatas.ascdId = '';
            this.getAjefShopCityDistrictList_data = [];
            if (ascId) {
                this.loadDistrictList(ascId);
            }
            this.partserch();
        },
        // 加载区县列表
        loadDistrictList(ascId) {
            const ascIdParam = ascId || this.formDatas.ascId;
            if (ascIdParam) {
                getAjefShopCityDistrictList({ ascId: ascIdParam }).then(res => {
                    this.getAjefShopCityDistrictList_data = res.data || [];
                });
            }
        },
        handlePreviewImage(url) {
            if (url) {
                const urls = Array.isArray(url) ? url : [url];
                if (urls.length === 1) {
                    // 单张图片，使用 window.open 打开
                    window.open(urls[0]);
                } else {
                    // 多张图片，使用 Element UI 的图片预览
                    this.$alert(`<div style="display: flex; flex-wrap: wrap; gap: 10px;">
                        ${urls.map(img => `<img src="${img}" style="max-width: 200px; max-height: 200px; object-fit: contain;">`).join('')}
                    </div>`, '图片预览', {
                        dangerouslyUseHTMLString: true,
                        customClass: 'image-preview-dialog'
                    });
                }
            }
        },
        checkBankInfo(row) {
            getAjefShopDetails({ asId: row.asId }).then(res => {
                const data = res.data;
                this.form = data;
                this.form.asOpenBankImage = data.asOpenBankImage && data.asOpenBankImage != 'error' ? data.asOpenBankImage.split(',') : [];
                console.log(this.form.asOpenBankImage,data.asOpenBankImage);
                if (data.asOpenBankImage.length > 0) {
                    this.form.asOpenBankImage.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList6, index, img)
                    })
                }
                this.isCheckBank = true;
            })

        },
        openMoneyBtn(asId) {
            //  对公提现,请输入金额,只允许数字格式
            this.$prompt("请输入提现金额?", "对公打款", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPattern: /^\d+(\.\d{1,2})?$/,
                inputErrorMessage: "金额格式不正确"
            }).then((value) => {
                console.log(value)
                addAjefApplyWithdrawPublicSys({ asId, aawMoney: value.value }).then(res => {
                    if (res.status == 200) {
                        this.$message({
                            type: "success",
                            message: "提现申请成功!",
                        });
                        this.theGetAjefShopDetails()
                    }
                })
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消",
                });
            });
        },
        handleDisableHeXiao(row) {
            this.$prompt("请输入禁用原因?", "确定要禁用核销吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    console.log(value)
                    updateAjefShopDisableHeXiao({ asId: row.asId, asDisableHeXiaoDes: value.value }).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: "禁用成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEnableHeXiao(row) {
            this.$prompt("请输入启用原因?", "确定要启用核销吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    console.log(value)
                    updateAjefShopEnableHeXiao({ asId: row.asId, asDisableHeXiaoDes: value.value }).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: "启用成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        // 打开批量禁用/解禁核销弹窗
        openBatchHeXiaoDialog(type) {
            this.batchHeXiaoType = type;
            this.batchHeXiaoDialog = true;
            this.batchHeXiaoSelectType = 'select';
            this.batchHeXiaoAsIds = [];
            this.batchHeXiaoDes = '';
            this.batchHeXiaoResultList = [];
            // 获取商户列表
            if (this.getAjefShopListQuick_data.length === 0) {
                getAjefShopListQuick({ pageSize: 0 }).then(res => {
                    this.getAjefShopListQuick_data = res.data || [];
                });
            }
        },
        // 关闭批量弹窗
        closeBatchHeXiaoDialog() {
            this.batchHeXiaoDialog = false;
            this.batchHeXiaoAsIds = [];
            this.batchHeXiaoDes = '';
        },
        // 上传文件获取商户ID
        handleBatchHeXiaoUpload(file) {
            let Data = new FormData();
            Data.append('file', file.raw);
            this.openLoading();
            uploadShopReturnAsIdsList(Data).then(res => {
                this.loadings.close();
                if (res.data && res.data.length > 0) {
                    this.batchHeXiaoAsIds = res.data.filter(item => item.asId).map(item => item.asId);
                    this.$message.success(`成功获取 ${this.batchHeXiaoAsIds.length} 个商户ID`);
                } else {
                    this.$message.warning('上传文件未获取到商户ID，请检查文件内容');
                }
            }).catch(() => {
                this.loadings.close();
                this.$message.error('上传文件解析失败');
            });
        },
        // 提交批量操作
        submitBatchHeXiao() {
            if (this.batchHeXiaoAsIds.length === 0) {
                this.$message.warning('请选择商户或上传文件获取商户ID');
                return;
            }
            const actionName = this.batchHeXiaoType === 'disable' ? '禁用' : '解禁';
            this.$confirm(`确定要批量${actionName} ${this.batchHeXiaoAsIds.length} 个商户的核销功能吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.batchHeXiaoLoading = true;
                const params = {
                    asIds: this.batchHeXiaoAsIds.join(','),
                    asDisableHeXiaoDes: this.batchHeXiaoDes
                };
                const apiMethod = this.batchHeXiaoType === 'disable' ? updateAjefShopDisableHeXiaoMulti : updateAjefShopEnableHeXiaoMulti;
                apiMethod(params).then(res => {
                    this.batchHeXiaoLoading = false;
                    if (res.data && res.data.length > 0) {
                        // 有失败的记录
                        this.batchHeXiaoResultList = res.data;
                        this.batchHeXiaoResultDialog = true;
                    } else {
                        // 全部成功
                        this.$message.success(`批量${actionName}成功`);
                        this.closeBatchHeXiaoDialog();
                        this.partserch();
                    }
                }).catch(() => {
                    this.batchHeXiaoLoading = false;
                    this.$message.error(`批量${actionName}失败`);
                });
            }).catch(() => {
                this.$message.info('已取消操作');
            });
        },
        // 关闭结果弹窗
        closeBatchHeXiaoResultDialog() {
            this.batchHeXiaoResultDialog = false;
            this.closeBatchHeXiaoDialog();
            this.partserch();
        },

        handleDisable(row) {
            this.$prompt("请输入禁用原因?", "确定要禁用吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    console.log(value)
                    updateAjefShopDisable({ asId: row.asId, asCheckDes: value.value }).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: "禁用成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEnable(row) {
            this.$prompt("请输入启用原因?", "确定要启用吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    console.log(value)
                    updateAjefShopEnable({ asId: row.asId, asCheckDes: value.value }).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: "启用成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        getDetailImgMsg(row) {
            getAjefShopDetails({ asId: row.asId }).then(res => { this.DetailImgMsg = [res.data]; this.isImgMsgShow = true })

        },
        theGetAjefShopDetails(){
           getAjefShopDetails({ asId: this.merchantDetail.asId }).then(res => { this.merchantDetail = res.data})
        },
        changeType(e) {
            getAjefShopReceiptTypeList({ pageSize: 0, asrtType: e }).then(res => {
                this.getAjefShopReceiptTypeList_data2 = res.data;
            });
        },
        handleBillShareType(row) {
            this.formBillShareType = {
                asId: row.asId,
                // asrtId: row.asrtId,
                asrtType: row.asrtType,
                billShareType: row.billShareType
            }
            this.billShareTypeShow = true
        },
        handleShopType(row) {
            this.formShopType = {
                asId: row.asId,
                astId: row.astId || ''
            }
            this.shopTypeShow = true
        },
        SureShopTypeBtn() {
            updateAjefShopTypeShop(this.formShopType).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.handleShopTypeClose()
                    this.getList()
                }
            })
        },
        handleShopTypeClose() {
            this.shopTypeShow = false
            this.formShopType = {
                astId: '',
                asId: ''
            }
        },
        handleRecord(row) {
            getAjefShopMilestoneList({ asId: row.asId }).then(res => {
                if (res.status == 200) {
                    this.tableRecord = res.data
                    this.diaRecord = true
                }
            })
        },
        handleCheckTable(row) {
            this.theRow = row;
            updateAjefShopCheckBefore({ asId: row.asId }).then(res => {
                if (res.status == 200) {
                    this.makeData = res.data;
                    this.isMakeShow = true;
                }
            })
        },
        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-shop/exportAjefShop',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '商户列表.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        handleChange(value) {
            console.log(value);
            let nodesInfo = this.$refs['cascader'].getCheckedNodes()
            this.form.asCity = nodesInfo[0].pathLabels.join(' ');
            console.log(this.form.asCity, nodesInfo)
        },
        expandChange(e) {
            console.log(e);
        },
        handleTopUpMoney(row) {
            this.$prompt("请输入充值金额?", "确定要充值吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    console.log(value)
                    updateAjefShopCheckPassGift({ asId: row.asId, giftMoney: value.value }).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: "充值成功!",
                            });

                            // this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleSpecsRelation(row) {
            this.currentSpecsShopId = row.asId;
            this.specsLoading = true;
            getAjefShopDetailsGoodsSpecs({ asId: row.asId }).then(res => {
                this.specsLoading = false;
                if (res.status == 200) {
                    this.merchantSpecsDetail = res.data || {};
                    this.specsList = res.item || [];
                    this.diaSpecsRelation = true;
                }
            }).catch(() => {
                this.specsLoading = false;
            });
        },
        openSpecsEditDialog(row) {
            const relationShop = row.specsRelationShop || {};
            // 将字符串转为数组 - 待审核图片
            let imagePreparingArr = [];
            if (relationShop.relationImagePreparing) {
                if (relationShop.relationImagePreparing.indexOf(',') > -1) {
                    imagePreparingArr = relationShop.relationImagePreparing.split(',');
                } else {
                    imagePreparingArr = [relationShop.relationImagePreparing];
                }
            }
            this.specsEditForm = {
                specsId: row.specsId,
                acrAmountStr: row.acrAmountStr,
                acrsrsId: relationShop.acrsrsId || '',
                relationImagePreparing: imagePreparingArr,
                relationNamePreparing: relationShop.relationNamePreparing || '',
                acrsrsStatusCheck: relationShop.acrsrsStatusCheck || null
            };
            this.diaSpecsEdit = true;
        },
        specsEditFileChange(file) {
            if (file && file.length > 0) {
                file.forEach(item => {
                    if (this.specsEditForm.relationImagePreparing.indexOf(item) == -1) {
                        this.specsEditForm.relationImagePreparing.push(item);
                    }
                });
            }
        },
        removeSpecsEditImage(index) {
            this.specsEditForm.relationImagePreparing.splice(index, 1);
        },
        saveSpecsEdit() {
            this.$confirm('确认保存该规格关联信息？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const saveData = {
                    asId: this.currentSpecsShopId,
                    acrsrsId: this.specsEditForm.acrsrsId,
                    relationId: this.specsEditForm.specsId,
                    relationNamePreparing: this.specsEditForm.relationNamePreparing,
                    relationImagePreparing: this.specsEditForm.relationImagePreparing.toString(),
                    acrsrsStatusCheck: this.specsEditForm.acrsrsStatusCheck
                };
                this.specsLoading = true;
                addOrUpdateAjefCertificateRecordSpecsRelationShop(saveData).then(res => {
                    this.specsLoading = false;
                    if (res.status == 200) {
                        this.$message.success('保存成功');
                        this.diaSpecsEdit = false;
                        // 刷新规格列表
                        getAjefShopDetailsGoodsSpecs({ asId: this.currentSpecsShopId }).then(res => {
                            if (res.status == 200) {
                                this.specsList = res.item || [];
                            }
                        });
                    } else {
                        this.$message.error('保存失败');
                    }
                }).catch(() => {
                    this.specsLoading = false;
                    this.$message.error('保存失败');
                });
            });
        },
        // 规格上架
        handleSpecsShelfUp(row) {
            if (!row.specsRelationShop || !row.specsRelationShop.acrsrsId) {
                this.$message.warning('规格关联信息不存在');
                return;
            }
            this.$confirm('确认上架该规格？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.specsLoading = true;
                updateAjefCertificateRecordSpecsRelationShopUp({ acrsrsId: row.specsRelationShop.acrsrsId }).then(res => {
                    this.specsLoading = false;
                    if (res.status == 200) {
                        this.$message.success('上架成功');
                        // 刷新规格列表
                        getAjefShopDetailsGoodsSpecs({ asId: this.currentSpecsShopId }).then(res => {
                            if (res.status == 200) {
                                this.specsList = res.item || [];
                            }
                        });
                    } else {
                        this.$message.error('上架失败');
                    }
                }).catch(() => {
                    this.specsLoading = false;
                    this.$message.error('上架失败');
                });
            });
        },
        // 规格下架
        handleSpecsShelfDown(row) {
            if (!row.specsRelationShop || !row.specsRelationShop.acrsrsId) {
                this.$message.warning('规格关联信息不存在');
                return;
            }
            this.$confirm('确认下架该规格？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.specsLoading = true;
                updateAjefCertificateRecordSpecsRelationShopDown({ acrsrsId: row.specsRelationShop.acrsrsId }).then(res => {
                    this.specsLoading = false;
                    if (res.status == 200) {
                        this.$message.success('下架成功');
                        // 刷新规格列表
                        getAjefShopDetailsGoodsSpecs({ asId: this.currentSpecsShopId }).then(res => {
                            if (res.status == 200) {
                                this.specsList = res.item || [];
                            }
                        });
                    } else {
                        this.$message.error('下架失败');
                    }
                }).catch(() => {
                    this.specsLoading = false;
                    this.$message.error('下架失败');
                });
            });
        },
        handleCheck(row) {
            this.$prompt("请输入审核备注?", "确定要审核通过吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    console.log(value)
                    updateAjefShopCheckPass({ asId: row.asId, asCheckDes: value.value }).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });
                        this.isMakeShow = false
                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleRefuseCheck(row) {
            this.$prompt("请输入审核备注?", "确定要拒绝通过吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    updateAjefShopCheckNotPass({ asId: row.asId, asCheckDes: value.value }).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });
                        this.isMakeShow = false
                        this.partserch()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        fileChange(file) {
            if (this.form.asBaseBusinessLicense.length > 0) {
                file.forEach((item) => {
                    if (this.form.asBaseBusinessLicense.indexOf(item) == -1) {
                        this.form.asBaseBusinessLicense.push(item);
                        const s = { url: item, name: item };
                        this.fileList.push(s);
                    }
                })
            } else {
                this.$set(this.form, 'asBaseBusinessLicense', file);
                file.forEach((item) => {
                    const s = { url: item, name: item };
                    this.fileList.push(s);
                })
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        removeAfter(file) {
            const url = this.form.asBaseBusinessLicense.findIndex(item => item === file)
            this.form.asBaseBusinessLicense.splice(url, 1)
        },
        fileChange2(file) {
            if (this.form.asBaseIdcardFace.length > 0) {
                file.forEach((item) => {
                    if (this.form.asBaseIdcardFace.indexOf(item) == -1) {
                        this.form.asBaseIdcardFace.push(item);
                        const s = { url: item, name: item };
                        this.fileList2.push(s);
                    }
                })
            } else {
                this.$set(this.form, 'asBaseIdcardFace', file);
                file.forEach((item) => {
                    const s = { url: item, name: item };
                    this.fileList2.push(s);
                })
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        removeAfter2(file) {
            const url = this.form.asBaseIdcardFace.findIndex(item => item === file)
            this.form.asBaseIdcardFace.splice(url, 1)
        },
        fileChange3(file) {
            if (this.form.asBaseIdcardNationalEmblem.length > 0) {
                file.forEach((item) => {
                    if (this.form.asBaseIdcardNationalEmblem.indexOf(item) == -1) {
                        this.form.asBaseIdcardNationalEmblem.push(item);
                        const s = { url: item, name: item };
                        this.fileList3.push(s);
                    }
                })
            } else {
                this.$set(this.form, 'asBaseIdcardNationalEmblem', file);
                file.forEach((item) => {
                    const s = { url: item, name: item };
                    this.fileList3.push(s);
                })
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        removeAfter3(file) {
            const url = this.form.asBaseIdcardNationalEmblem.findIndex(item => item === file)
            this.form.asBaseIdcardNationalEmblem.splice(url, 1)
        },
        fileChange4(file) {
            if (this.form.asBaseShopHeader.length > 0) {
                file.forEach((item) => {
                    if (this.form.asBaseShopHeader.indexOf(item) == -1) {
                        this.form.asBaseShopHeader.push(item);
                        const s = { url: item, name: item };
                        this.fileList4.push(s);
                    }
                })
            } else {
                this.$set(this.form, 'asBaseShopHeader', file);
                file.forEach((item) => {
                    const s = { url: item, name: item };
                    this.fileList4.push(s);
                })
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        removeAfter4(file) {
            const url = this.form.asBaseShopHeader.findIndex(item => item === file)
            this.form.asBaseShopHeader.splice(url, 1)
        },
        fileChange5(file) {
            if (this.form.asBaseShopIn.length > 0) {
                file.forEach((item) => {
                    if (this.form.asBaseShopIn.indexOf(item) == -1) {
                        this.form.asBaseShopIn.push(item);
                        const s = { url: item, name: item };
                        this.fileList5.push(s);
                    }
                })
            } else {
                this.$set(this.form, 'asBaseShopIn', file);
                file.forEach((item) => {
                    const s = { url: item, name: item };
                    this.fileList5.push(s);
                })
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        removeAfter5(file) {
            const url = this.form.asBaseShopIn.findIndex(item => item === file)
            this.form.asBaseShopIn.splice(url, 1)
        },
        fileChange6(file) {
            if (this.form.asOpenBankImage.length > 0) {
                file.forEach((item) => {
                    if (this.form.asOpenBankImage.indexOf(item) == -1) {
                        this.form.asOpenBankImage.push(item);
                        const s = { url: item, name: item };
                        this.fileList6.push(s);
                    }
                })
            } else {
                this.$set(this.form, 'asOpenBankImage', file);
                file.forEach((item) => {
                    const s = { url: item, name: item };
                    this.fileList6.push(s);
                })
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        removeAfter6(file) {
            const url = this.form.asOpenBankImage.findIndex(item => item === file)
            this.form.asOpenBankImage.splice(url, 1)
        },
        addMerchantUser(row) {
            this.theAddType = row;
            this.isUserShow = true;
            this.editUser = false;
        },

        getMerchantUserList() {
            getAjefUserShopList({ asId: this.theRowId, ...this.formUserDatas }).then(res => {
                this.MerchantUserData = res.data;
                this.totalCountUser = res.total;
            })
        },
        handleMerchantUser(row) {
            this.theRowId = row.asId;
            this.formUserDatas.asId = row.asId;
            getAjefShopDetails({ asId: row.asId }).then(res => { this.merchantDetail = res.data })
            getAjefUserShopList({ asId: row.asId }).then(res => {
                this.totalCountUser = res.total;
                this.MerchantUserData = res.data;
                this.isMerchantUserShow = true;
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsKey({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjAssetsFireEquipment(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;

            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjAssetsFireEquipmentStatus({ asId: this.theRow.asId, aakStatus: this.dialogStatusValue }).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.dialogStatusValue = ''
                }
            })
            this.dialogStatus = false;
        },
        closeStatus() {
            this.dialogStatus = false;
            this.dialogStatusValue = ''
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjefShop({ asIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleUserDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAjefUserShop({ ausId: row.ausId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.getMerchantUserList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAjefShop({ asId: row.asId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleReview(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialogFh = true;
            this.$nextTick(() => {
                this.form = data;
                this.form.asBaseBusinessLicense = data.asBaseBusinessLicense ? data.asBaseBusinessLicense.split(',') : [];
                if (data.asBaseBusinessLicense.length > 0) {
                    this.form.asBaseBusinessLicense.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList, index, img)
                    })
                }
                this.form.asBaseIdcardFace = data.asBaseIdcardFace ? data.asBaseIdcardFace.split(',') : [];
                if (data.asBaseIdcardFace.length > 0) {
                    this.form.asBaseIdcardFace.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList2, index, img)
                    })
                }
                this.form.asBaseIdcardNationalEmblem = data.asBaseIdcardNationalEmblem ? data.asBaseIdcardNationalEmblem.split(',') : [];
                if (data.asBaseIdcardNationalEmblem.length > 0) {
                    this.form.asBaseIdcardNationalEmblem.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList3, index, img)
                    })
                }
                this.form.asBaseShopHeader = data.asBaseShopHeader ? data.asBaseShopHeader.split(',') : [];
                if (data.asBaseShopHeader.length > 0) {
                    this.form.asBaseShopHeader.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList4, index, img)
                    })
                }
                this.form.asBaseShopIn = data.asBaseShopIn ? data.asBaseShopIn.split(',') : [];
                if (data.asBaseShopIn.length > 0) {
                    this.form.asBaseShopIn.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList5, index, img)
                    })
                }
                this.form.asOpenBankImage = data.asOpenBankImage && data.asOpenBankImage != 'error' ? data.asOpenBankImage.split(',') : [];
                if (data.asOpenBankImage.length > 0) {
                    this.form.asOpenBankImage.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList6, index, img)
                    })
                }
            })
        },
        // 排序功能
        handleEditOrder(row) {
            this.orderDialog = true;
            this.formOrder = {
                asId: row.asId,
                asOrder: row.asOrder || 0
            };
        },
        // 确认排序
        sureOrderBtn() {
            const data = {
                asId: this.formOrder.asId,
                asOrder: this.formOrder.asOrder
            };
            updateAjefShopOrder(data).then(res => {
                if (res.data) {
                    this.$message.success('排序成功');
                    this.orderDialog = false;
                    this.getList();
                }
            }).catch(() => {
                // 取消操作
            });
        },
        // ==================== 商户介绍相关方法 ====================
        // 打开商户介绍弹框
        handleIntroduction(row) {
            this.introductionCurrentShop = row;
            this.introductionDialog = true;
            this.introductionLoading = true;
            this.introductionFileList = [];
            this.introductionForm = {
                aseId: null,
                asId: row.asId,
                aseIntroduce: []
            };

            // 获取商户介绍数据
            getAjefShopExpandDetails({ asId: row.asId }).then(res => {
                this.introductionLoading = false;
                if (res.data) {
                    this.introductionForm.aseId = res.data.aseId;
                    this.introductionForm.asId = res.data.asId;

                    // 解析图片数据
                    if (res.data.aseIntroduce) {
                        try {
                            const images = JSON.parse(res.data.aseIntroduce);
                            this.introductionForm.aseIntroduce = images;
                            // 转换为组件需要的格式
                            this.introductionFileList = images.map(url => ({ url }));
                        } catch (e) {
                            console.error('解析商户介绍图片失败:', e);
                            this.introductionForm.aseIntroduce = [];
                            this.introductionFileList = [];
                        }
                    }
                }
            }).catch(err => {
                this.introductionLoading = false;
                this.$message.error('获取商户介绍失败');
            });
        },
        // 处理图片上传
        handleIntroductionFileChange(files) {
            if (files && files.length > 0) {
                files.forEach(url => {
                    this.introductionFileList.push({ url });
                    this.introductionForm.aseIntroduce.push(url);
                });
            }
        },
        // 删除图片
        handleIntroductionImageDelete(index) {
            this.introductionFileList.splice(index, 1);
            this.introductionForm.aseIntroduce.splice(index, 1);
        },
        // 保存商户介绍
        handleIntroductionSave() {
            // 检查是否有上传图片
            if (this.introductionForm.aseIntroduce.length === 0) {
                this.$message.warning('请先上传图片');
                return;
            }

            this.introductionLoading = true;

            // 如果没有aseId，先获取商户扩展信息（后端会自动创建）
            const checkAndSave = () => {
                const data = {
                    aseId: this.introductionForm.aseId || -1, // 使用-1触发后端创建
                    aseIntroduce: JSON.stringify(this.introductionForm.aseIntroduce)
                };

                updateAjefShopExpandIntroduce(data).then(res => {
                    this.introductionLoading = false;
                    this.$message.success('保存成功');
                    this.introductionDialog = false;
                }).catch(err => {
                    this.introductionLoading = false;
                    this.$message.error('保存失败');
                });
            };

            // 如果没有aseId，先获取商户扩展信息
            if (!this.introductionForm.aseId) {
                getAjefShopExpandDetails({ asId: this.introductionCurrentShop.asId }).then(res => {
                    if (res.data && res.data.aseId) {
                        this.introductionForm.aseId = res.data.aseId;
                    }
                    checkAndSave();
                }).catch(err => {
                    this.introductionLoading = false;
                    this.$message.error('获取商户信息失败');
                });
            } else {
                checkAndSave();
            }
        },
        // 关闭弹框
        handleIntroductionClose() {
            this.introductionFileList = [];
            this.introductionForm = {
                aseId: null,
                asId: null,
                aseIntroduce: []
            };
            this.introductionCurrentShop = null;
        },
        // 打开编辑商户地市和名称弹窗
        openCityNameDialog(row) {
            this.editCityName = {
                asId: row.asId,
                asCity: row.asCity || '',
                asName: row.asName || '',
            };
            this.editCityNameArr = [];
            this.cityNameDialog = true;
        },
        // 编辑弹窗级联选择器变化
        handleEditCityChange(value) {
            if (this.$refs['cascaderEdit']) {
                const nodesInfo = this.$refs['cascaderEdit'].getCheckedNodes();
                if (nodesInfo && nodesInfo.length > 0) {
                    this.editCityName.asCity = nodesInfo[0].pathLabels.join(' ');
                }
            }
        },
        // 保存编辑商户地市和名称
        saveCityNameBtn() {
            if (!this.editCityName.asCity && !this.editCityName.asName) {
                this.$message.warning('请至少修改一项内容');
                return;
            }
            this.cityNameLoading = true;
            const data = {
                asId: this.editCityName.asId,
                asCity: this.editCityName.asCity,
                asName: this.editCityName.asName,
            };
            updateAjefShopCityAndName(data).then(res => {
                this.cityNameLoading = false;
                if (res.status == 200) {
                    this.$message.success('修改成功');
                    this.cityNameDialog = false;
                    this.getList();
                }
            }).catch(() => {
                this.cityNameLoading = false;
            });
        },
        handleEdit(row) {
            // 先打开弹窗
            this.dialog = true;
            this.edit = true;

            // 调用详情接口获取最新数据
            getAjefShopDetails({ asId: row.asId }).then(res => {
                const data = res.data || {};
                this.$nextTick(() => {
                    this.form = data;
                    this.form.asBaseBusinessLicense = data.asBaseBusinessLicense ? data.asBaseBusinessLicense.split(',') : [];
                    if (this.form.asBaseBusinessLicense.length > 0) {
                        this.form.asBaseBusinessLicense.forEach((item, index) => {
                            const img = {
                                name: item,
                                url: item,
                            }
                            this.$set(this.fileList, index, img)
                        })
                    }
                    this.form.asBaseIdcardFace = data.asBaseIdcardFace ? data.asBaseIdcardFace.split(',') : [];
                    if (this.form.asBaseIdcardFace.length > 0) {
                        this.form.asBaseIdcardFace.forEach((item, index) => {
                            const img = {
                                name: item,
                                url: item,
                            }
                            this.$set(this.fileList2, index, img)
                        })
                    }
                    this.form.asBaseIdcardNationalEmblem = data.asBaseIdcardNationalEmblem ? data.asBaseIdcardNationalEmblem.split(',') : [];
                    if (this.form.asBaseIdcardNationalEmblem.length > 0) {
                        this.form.asBaseIdcardNationalEmblem.forEach((item, index) => {
                            const img = {
                                name: item,
                                url: item,
                            }
                            this.$set(this.fileList3, index, img)
                        })
                    }
                    this.form.asBaseShopHeader = data.asBaseShopHeader ? data.asBaseShopHeader.split(',') : [];
                    if (this.form.asBaseShopHeader.length > 0) {
                        this.form.asBaseShopHeader.forEach((item, index) => {
                            const img = {
                                name: item,
                                url: item,
                            }
                            this.$set(this.fileList4, index, img)
                        })
                    }
                    this.form.asBaseShopIn = data.asBaseShopIn ? data.asBaseShopIn.split(',') : [];
                    if (this.form.asBaseShopIn.length > 0) {
                        this.form.asBaseShopIn.forEach((item, index) => {
                            const img = {
                                name: item,
                                url: item,
                            }
                            this.$set(this.fileList5, index, img)
                        })
                    }
                    this.form.asOpenBankImage = data.asOpenBankImage && data.asOpenBankImage != 'error' ? data.asOpenBankImage.split(',') : [];
                    if (this.form.asOpenBankImage.length > 0) {
                        this.form.asOpenBankImage.forEach((item, index) => {
                            const img = {
                                name: item,
                                url: item,
                            }
                            this.$set(this.fileList6, index, img)
                        })
                    }
                })
            }).catch(err => {
                this.$message.error('获取商户详情失败');
                this.dialog = false;
                this.edit = false;
            });
        },
        handleUserEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.isUserShow = true;
            this.editUser = true;
            this.$nextTick(() => {
                this.formUser = data;
            })
        },
        SureTypeBtn() {
            updateAjefShopBillShareTypeShop(this.formBillShareType).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.handleTypeClose()
                    this.getList()
                }
            })
        },
        handleTypeClose() {
            this.billShareTypeShow = false
            this.formBillShareType = {
                asId: '',
                billShareType: ''
            }
        },
        SureUserBtn() {
            if (!this.editUser) {
                if (this.theAddType == '1') {
                    this.$confirm("是否确定要新增, 是否继续?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            this.formUser.asId = this.theRowId
                            addAjefUserShopAdmin(this.formUser).then(res => {
                                if (res.data) {
                                    this.$message({
                                        type: "success",
                                        message: "新增成功!",
                                    });
                                    this.handleUserClose()
                                    this.getMerchantUserList()
                                }
                            })
                        }).catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        })
                }
                if (this.theAddType == '2') {
                    this.$confirm("是否确定要新增, 是否继续?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            this.formUser.asId = this.theRowId
                            addAjefUserShopUser(this.formUser).then(res => {
                                if (res.data) {
                                    this.$message({
                                        type: "success",
                                        message: "新增成功!",
                                    });
                                    this.handleUserClose()
                                    this.getMerchantUserList()
                                }
                            })
                        }).catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        })
                }

            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.formUser.asId = this.theRowId
                        updateAjefUserShop(this.formUser).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleUserClose()
                                this.getMerchantUserList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        newForm.asBaseBusinessLicense = newForm.asBaseBusinessLicense ? newForm.asBaseBusinessLicense.toString() : []
                        newForm.asBaseIdcardFace = newForm.asBaseIdcardFace ? newForm.asBaseIdcardFace.toString() : []
                        newForm.asBaseIdcardNationalEmblem = newForm.asBaseIdcardNationalEmblem ? newForm.asBaseIdcardNationalEmblem.toString() : []
                        newForm.asBaseShopHeader = newForm.asBaseShopHeader ? newForm.asBaseShopHeader.toString() : []
                        newForm.asBaseShopIn = newForm.asBaseShopIn ? newForm.asBaseShopIn.toString() : []
                        newForm.asOpenBankImage = newForm.asOpenBankImage ? newForm.asOpenBankImage.toString() : []

                        addAjefShop(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        newForm.asBaseBusinessLicense = newForm.asBaseBusinessLicense ? newForm.asBaseBusinessLicense.toString() : []
                        newForm.asBaseIdcardFace = newForm.asBaseIdcardFace ? newForm.asBaseIdcardFace.toString() : []
                        newForm.asBaseIdcardNationalEmblem = newForm.asBaseIdcardNationalEmblem ? newForm.asBaseIdcardNationalEmblem.toString() : []
                        newForm.asBaseShopHeader = newForm.asBaseShopHeader ? newForm.asBaseShopHeader.toString() : []
                        newForm.asBaseShopIn = newForm.asBaseShopIn ? newForm.asBaseShopIn.toString() : []
                        newForm.asOpenBankImage = newForm.asOpenBankImage ? newForm.asOpenBankImage.toString() : []
                        updateAjefShop(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        SureBtnFs() {
            this.$confirm("是否确定要新增, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const newForm = JSON.parse(JSON.stringify(this.form))
                    newForm.asBaseBusinessLicense = newForm.asBaseBusinessLicense ? newForm.asBaseBusinessLicense.toString() : []
                    newForm.asBaseIdcardFace = newForm.asBaseIdcardFace ? newForm.asBaseIdcardFace.toString() : []
                    newForm.asBaseIdcardNationalEmblem = newForm.asBaseIdcardNationalEmblem ? newForm.asBaseIdcardNationalEmblem.toString() : []
                    newForm.asBaseShopHeader = newForm.asBaseShopHeader ? newForm.asBaseShopHeader.toString() : []
                    newForm.asBaseShopIn = newForm.asBaseShopIn ? newForm.asBaseShopIn.toString() : []
                    newForm.asOpenBankImage = newForm.asOpenBankImage ? newForm.asOpenBankImage.toString() : []
                    addAjefShopAgain(newForm).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "新增成功!",
                            });
                            this.handleClose()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        SureCheckBtn() {
            this.$confirm("是否确定要编辑, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const newForm = JSON.parse(JSON.stringify(this.form))
                    newForm.asOpenBankImage = newForm.asOpenBankImage ? newForm.asOpenBankImage.toString() : []
                    updateAjefShopBankCheck(newForm).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "编辑成功!",
                            });
                            this.handleCheckClose()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleCheckClose() {
            this.isCheckBank = false;
            this.$refs['formRef'].resetFields();
            this.fileList6 = [];
        },
        handleClose() {
            this.dialog = false;
            this.dialogFh = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
            this.fileList = [];
            this.fileList2 = [];
            this.fileList3 = [];
            this.fileList4 = [];
            this.fileList5 = [];
            this.fileList6 = [];
        },
        // 关闭弹框
        handleUserClose() {
            this.isUserShow = false;
            this.editUser = false;
            this.$refs['formRef2'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.asId = row.asId
                    console.log(jsonObj);
                    updateAjefShop(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageSizeChange_User(pageSize) {
            this.formUserDatas.pageSize = pageSize;
            this.getMerchantUserList();
        },
        pageNumberChange_user(pageIndex) {
            console.log(pageIndex);
            this.formUserDatas.currentPage = pageIndex;
            getAjefUserShopList(this.formUserDatas).then((res) => {
                this.MerchantUserData = res.data;
                this.totalCountUser = res.total;
                // this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getAjefShopList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            }).catch(() => {
                this.tableLoading = false;
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getAjefShopList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getAjefShopList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

/* 自定义表格加载动画样式 */
.table-loading .el-loading-spinner {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 50%;
    width: 80px;
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.table-loading .el-loading-spinner .el-icon-loading {
    font-size: 32px;
    color: #fff;
    animation: rotate 1s linear infinite;
}

.table-loading .el-loading-spinner .el-loading-text {
    color: #fff;
    font-size: 14px;
    margin-top: 8px;
    font-weight: 500;
}

@keyframes rotate {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

/* 商户介绍弹框样式 */
.introduction-image-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 20px;
}
.introduction-image-item {
    position: relative;
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    background: #f5f7fa;
}
.introduction-img {
    width: 100%;
    display: block;
}
.introduction-image-delete {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #fff;
    transition: background 0.3s;
}
.introduction-image-delete:hover {
    background: rgba(245, 108, 108, 0.9);
}
.introduction-upload-area {
    border: 2px dashed #dcdfe6;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    background: #fafafa;
    transition: border-color 0.3s;
}
.introduction-upload-area:hover {
    border-color: #409eff;
}
.introduction-empty {
    text-align: center;
    padding: 40px 0;
    color: #909399;
}
.introduction-empty i {
    font-size: 48px;
    margin-bottom: 10px;
}
.introduction-empty p {
    margin: 0;
}
</style>